import { createContext, useEffect, useState } from "react";

import { isLoggedIn } from "../functions/server-requests/user";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isApiResCame: false,
    isLoggedIn: false,
    userId: "",
    name: ""
  });

  useEffect(() => {
    const checkIsLoggedIn = async () => {
      const res = await isLoggedIn();

      // setting up "isApiResCame"
      setAuth({
        ...auth,
        isApiResCame: true, // changed from false to true
      });

      if (res.status === 200) {
        setAuth({
          ...auth,
          isApiResCame: true,
          isLoggedIn: true,
          userId: res.data.userDetails._id,
          name: res.data.userDetails.name
        });
      }
    }

    checkIsLoggedIn();
  }, []);
  // in above useEffect hook, the empty array is required
  // else the function "checkIsLoggedIn" is getting called infinite times

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthContext;